class VariantSlider extends HTMLElement {
    constructor() {
        super();

        // Access data attributes directly from the custom element
        const sliderPagination = this.dataset.sliderPagination === 'true';
        const sliderArrow = this.dataset.sliderArrow === 'true';
        const sliderAutoplay = this.dataset.sliderAutoplay === 'true';

        // Initialize Flickity on the .flickty-wrapper within this element
        const sliderElement = this.querySelector("#color-variant-slider");;
        if (!sliderElement) {
            console.error("Flickity wrapper not found within variant-slider.");
            return;
        }

        this.flkty = new Flickity(sliderElement, {
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            autoPlay: sliderAutoplay ? 3000 : false,
            pauseAutoPlayOnHover: true,
            pageDots: sliderPagination,
            prevNextButtons: sliderArrow
        });
    }

    disconnectedCallback() {
        // Destroy Flickity instance when element is removed from the DOM
        if (this.flkty) {
            this.flkty.destroy();
        }
    }
}

// Define the custom element
customElements.define('variant-slider', VariantSlider);
